exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-check .form-check-sign[data-v-40023410]:after{color:#fff}", ""]);

// exports
